/* @flow */

/*
 * manages which expert opinion is selected in the poll builder
 */
import { createSelector } from 'reselect'
import { getRoot } from '../stores/rootSelector'

import type {
  RootState,
  Action,
  FluxStandardAction,
  ExpertOpinion,
  Vector,
} from '../types'

import { ActionRequiresPropertyError } from '../helpers'

export const STATE_KEY = 'pollBuilderSelectedExpertOpinion'

export const SET_SELECTED_EXPERT_OPINION = 'opinary/SET_SELECTED_EXPERT_OPINION'
export const SET_SELECTED_EXPERT_OPINION_NAME =
  'opinary/SET_SELECTED_EXPERT_OPINION_NAME'
export const CLEAR_EXPERT_OPINION_SELECTION =
  'opinary/CLEAR_EXPERT_OPINION_SELECTION'
export const SET_POSITION_OF_NEW_EXPERT_OPINION =
  'opinary/SET_POSITION_OF_NEW_EXPERT_OPINION'

export function setSelectedExpertOpinion(expertOpinion: ExpertOpinion): Action {
  return {
    type: SET_SELECTED_EXPERT_OPINION,
    expertOpinion,
  }
}

export function setSelectedExpertOpinionName(name: string): FluxStandardAction {
  return {
    type: SET_SELECTED_EXPERT_OPINION_NAME,
    payload: name,
  }
}

export function setPositionOfNewExpertOpinion(position: ?Vector): Action {
  return {
    type: SET_POSITION_OF_NEW_EXPERT_OPINION,
    position,
  }
}

export function clearExpertOpinionSelection(): Action {
  return {
    type: CLEAR_EXPERT_OPINION_SELECTION,
  }
}

export function selectIsExpertOpinionSelected(state: RootState): boolean {
  return state[STATE_KEY] != null
}

export const selectSelectedExpertOpinion = createSelector(
  getRoot,
  ({ pollBuilderSelectedExpertOpinion }) => pollBuilderSelectedExpertOpinion
)

export const selectSelectedExpertOpinionIconId = createSelector(
  selectSelectedExpertOpinion,
  ({ iconId }) => iconId
)

export const selectPositionOfNewExpertOpinion = createSelector(
  selectSelectedExpertOpinion,
  ({ x, y }) => ({ x, y })
)

export default function reducer(
  state: ?ExpertOpinion = null,
  action: Action | FluxStandardAction
) {
  switch (action.type) {
    case SET_SELECTED_EXPERT_OPINION:
      if (!action.expertOpinion) {
        throw new ActionRequiresPropertyError(
          SET_SELECTED_EXPERT_OPINION,
          'expertOpinion'
        )
      }
      return action.expertOpinion
    case SET_SELECTED_EXPERT_OPINION_NAME:
      if (action.payload === null) {
        throw new ActionRequiresPropertyError(
          SET_SELECTED_EXPERT_OPINION_NAME,
          'payload'
        )
      }
      return {
        ...state,
        name: action.payload,
      }
    case SET_POSITION_OF_NEW_EXPERT_OPINION:
      if (!action.position || !action.position.x || !action.position.y) {
        throw new ActionRequiresPropertyError(
          SET_POSITION_OF_NEW_EXPERT_OPINION,
          'position'
        )
      }
      return {
        ...state,
        x: action.position.x,
        y: action.position.y,
      }
    case CLEAR_EXPERT_OPINION_SELECTION:
      return null
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/stores/pollBuilderSelectedExpertOpinion.js